import { Button, Checkbox } from "antd";
import SignatureCanvas from 'react-signature-canvas';
import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Config from "../../../Config";

import "./mrtt_client_screen.css";
import GeneralBloc from "../../../bloc/general_bloc";
import UtilBloc from "../../../bloc/util_bloc";
import { ReactComponent as ProposalIcon } from "../../../Proposal2.svg";
import { ReactComponent as DeclarationIcon } from "../../../Declaration.svg";
import { ReactComponent as SignIcon } from "../../../Draft.svg";
import AppModal from "../../component/app_modal/app_modal";
import ClientBloc from "../../../bloc/client_bloc";
import ProposalBloc from "../../../bloc/mrtt_proposal_bloc";
import App_mobile_loading from "../../dialog/app_mobile_loading";
import AppSelectField from "../../component/app_select_field/app_select_field";
import FormsBloc from "../../../bloc/forms_bloc";

const MIN_SIGNATURE_SIZE_KB = 3;
const MIN_SIGNATURE_SIZE_BYTES = MIN_SIGNATURE_SIZE_KB * 1024;
const SIGNATURE_SIZE_ERROR_MESSAGE =
    `Your signature is too small. Please provide a complete signature (at least ${MIN_SIGNATURE_SIZE_KB}KB).`;

class ReviewSignature extends Component {
    constructor(props) {
        super(props);
        this.state = {
            client: Config.context,
            userDataHeader: null,
            userSettings: {},
            consentDetails: { answers: [] },
            confirmSignature: false,
            signatureContent: null,
            cancelModalOpen: false,
            placeOfSigning: null,
            stateList: [],
            loading: false,
            isOpen: false,
            title: '',
            message: '',
            canvasWidth: 300, // default fallback
            signatureError: '',
        };
        this.sigPad = null;
    }

    // Calculate responsive canvas width (safe for mobile)
    updateCanvasWidth = () => {
        const padding = 40; // left + right padding
        const maxWidth = 500;
        const width = Math.min(window.innerWidth - padding, maxWidth);
        this.setState({ canvasWidth: width > 0 ? width : 300 });
    };

    clear = () => {
        if (this.sigPad) {
            this.sigPad.clear();
            this.setState({ signatureContent: null, signatureError: '' });
        }
    };

    // Get the decoded size (in bytes) of a base64 encoded image
    getSignatureSizeInBytes = (base64Content) => {
        if (!base64Content) return 0;
        const content = base64Content.split("base64,")[1] || base64Content;
        if (content.endsWith("==")) return Math.floor((content.length * 3) / 4) - 2;
        if (content.endsWith("=")) return Math.floor((content.length * 3) / 4) - 1;
        return Math.floor((content.length * 3) / 4);
    };

    isSignatureValid = (signatureContent) => {
        return (
            !UtilBloc.isNullOrEmpty(signatureContent) &&
            this.getSignatureSizeInBytes(signatureContent) >= MIN_SIGNATURE_SIZE_BYTES
        );
    };

    showSignatureSizeError = () => {
        this.setState({
            signatureContent: null,
            signatureError: SIGNATURE_SIZE_ERROR_MESSAGE,
            title: 'Notification',
            message: SIGNATURE_SIZE_ERROR_MESSAGE,
            isOpen: true,
        });
    };

    saveSignature = () => {
        if (!this.sigPad) return;

        try {
            const strImage = this.sigPad.getTrimmedCanvas().toDataURL('image/png');
            const signatureContent = strImage.split("base64,")[1];

            if (!this.isSignatureValid(signatureContent)) {
                this.showSignatureSizeError();
                return;
            }

            this.setState({ signatureContent, signatureError: '' });
        } catch (error) {
            console.error("Failed to save signature:", error);
        }
    };

    getProposalId() {
        return this.props.match.params.itemId;
    }

    componentDidMount() {
        this.updateCanvasWidth();
        window.addEventListener('resize', this.updateCanvasWidth);
        this.setInitialData();
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateCanvasWidth);
    }

    async setInitialData() {
        this.setState({ loading: true });
        try {
            const result = await ProposalBloc.getFormDetailProposal(
                this.getProposalId(),
                Config.formProposalDetailMapping[10].category,
                'client'
            );
            const stateList = await FormsBloc.getStateList('client');

            if (result.success) {
                this.setState({
                    consentDetails: result.data[0]?.proposal_attr?.properties?.answers || { answers: [] },
                    stateList: stateList?.data || [],
                });
            }
        } catch (error) {
            console.error("Failed to load initial data:", error);
        } finally {
            this.setState({ loading: false });
        }
    }

    handleCancelModalOpen() {
        this.setState({ cancelModalOpen: true });
    }

    handleCancelModalClose() {
        this.setState({ cancelModalOpen: false });
    }

    handleCancelReview() {
        window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_auth}`)
    }

    handleValidation() {
        const { confirmSignature, signatureContent, placeOfSigning } = this.state;
        if (
            confirmSignature &&
            this.isSignatureValid(signatureContent) &&
            !UtilBloc.isNullOrEmpty(placeOfSigning)
        ) {
            return false; // enabled
        }
        return true; // disabled
    }

    handleChecked(val) {
        this.setState({ confirmSignature: val });
    }

    async handleGoNext() {
        if (!this.isSignatureValid(this.state.signatureContent)) {
            this.showSignatureSizeError();
            return;
        }

        this.setState({ loading: true });

        try {
            const savedCollectInformation = sessionStorage.getItem('collectInformation');
            const strImage = this.state.signatureContent;

            const consentData = {
                answers: Array.isArray(this.state.consentDetails)
                    ? [...this.state.consentDetails]
                    : (this.state.consentDetails?.answers || []),
                personalInformationCollected: savedCollectInformation === 'true',
            };

            const signatureConsent = {
                status: this.state.confirmSignature ? 'Yes' : 'No',
                id: 'signatureConsent',
                compulsory: 'Yes',
                title: '',
                desc: '',
            };

            const signatureConsentExist = consentData.answers.findIndex(
                (item) => item.id === 'signatureConsent'
            );

            if (signatureConsentExist !== -1) {
                consentData.answers = consentData.answers.map((item) => {
                    if (item.id === 'signatureConsent') {
                        return { ...item, status: this.state.confirmSignature ? 'Yes' : 'No' };
                    }
                    return item;
                });
            } else {
                consentData.answers.push(signatureConsent);
            }

            const submitConsentResult = await ProposalBloc.saveFormProposal(
                this.getProposalId(),
                'THIRD_PARTY_CONSENT',
                consentData,
                'client'
            );

            const submitSignatureResult = await ClientBloc.submitClientSignature(
                this.getProposalId(),
                {
                    signature: strImage,
                    placeOfSigning: this.state.placeOfSigning,
                }
            );

            if (submitConsentResult.success && submitSignatureResult.success) {
                window.location.replace(
                    `/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_success}/${this.getProposalId()}`
                );
            } else {
                this.setState({
                    title: 'Notification',
                    message: submitSignatureResult.message || submitConsentResult.message || 'Something went wrong',
                    isOpen: true,
                });
            }
        } catch (error) {
            console.error("Submit error:", error);
            this.setState({
                title: 'Notification',
                message: 'An unexpected error occurred. Please try again.',
                isOpen: true,
            });
        } finally {
            this.setState({ loading: false });
        }
    }

    handleGoBack() {
        sessionStorage.removeItem('collectInformation');
        window.location.replace(`/${this.state.client}/${Config.routes.generic.fwd + Config.routes.generic.mrtt}/${Config.routes.generic.client_review_declaration}/${this.getProposalId()}`)
    }

    showMessageModal = () => {
        return (
            <AppModal
                open={this.state.isOpen}
                handleModalClose={() => this.setState({ isOpen: false })}
                title={this.state.title}
                subtitle={this.state.message}
                positiveButtonText={'Close'}
                handlePositivePress={() => this.setState({ isOpen: false })}
                closable={false}
            />
        );
    };

    loadingContent() {
        return (
            <div style={{ height: "100%" }}>
                <App_mobile_loading isLoading={this.state.loading} />
            </div>
        );
    }

    stepHeader() {
        return (
            <div className="column d-flex align-items-center justify-content-center">
                <div className="d-flex row pr-2">
                    <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                        <div className="process_step">
                            <ProposalIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                        </div>
                        <div className="">Proposal</div>
                    </div>
                </div>
                <div className="line_through_complete"></div>
                <div className="d-flex row pr-2">
                    <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                        <div className="process_step">
                            <DeclarationIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                        </div>
                        <div className="">Declaration</div>
                    </div>
                </div>
                <div className="line_through_complete"></div>
                <div className="d-flex row p-2">
                    <div className="align-items-center justify-content-center" style={{ textAlign: '-webkit-center' }}>
                        <div className="process_step">
                            <SignIcon fill={'#FFFFFF'} style={{ height: 24, width: 24 }} />
                        </div>
                        <div className="">Signature</div>
                    </div>
                </div>
            </div>
        );
    }

    renderBottomBar() {
        return (
            <div className="bottom_container d-flex justify-content-center">
                <Button
                    style={{
                        backgroundColor: 'transparent',
                        color: '#EE7623',
                        width: '50%',
                        height: 49,
                        border: '0px',
                    }}
                    onClick={() => this.handleCancelModalOpen()}
                >
                    Cancel
                </Button>
                <Button
                    disabled={this.handleValidation()}
                    style={{
                        backgroundColor: '#183028',
                        color: 'white',
                        width: '50%',
                        height: 49,
                        opacity: this.handleValidation() ? 0.7 : 1,
                    }}
                    onClick={() => this.handleGoNext()}
                >
                    Submit
                </Button>
            </div>
        );
    }

    render() {
        return (
            <div className="client_container" style={{ height: '100%' }}>
                {this.state.loading && this.loadingContent()}

                <div
                    className="mobile_container justify-content-center"
                    style={{
                        height: window.innerHeight,
                        overflowY: 'scroll',
                        paddingBottom: 150,
                    }}
                >
                    <div className="client_header justify-content-between px-4">
                        <img
                            src={
                                GeneralBloc.getAssetsContextPath() +
                                `/assets/icons/Back.svg`
                            }
                            onClick={() => this.handleGoBack()}
                            alt="Back"
                            style={{ width: 15, height: 15, cursor: 'pointer' }}
                        />
                        Review and Sign
                        <div></div>
                    </div>

                    {this.renderBottomBar()}

                    <div className="d-flex justify-content-center p-4 row m-0 w-100">
                        {this.stepHeader()}

                        <div className="mt-4 w-100">
                            <div className="client_instruction_header">
                                Please provide your signature to proceed with the proposal.
                            </div>

                            {/* Signature Pad - Responsive */}
                            <div
                                className="mt-3 signature_container"
                                style={{
                                    position: 'relative',
                                    width: '100%',
                                    maxWidth: '100%',
                                    overflow: 'hidden',
                                }}
                            >
                                <SignatureCanvas
                                    penColor="black"
                                    ref={(ref) => { this.sigPad = ref; }}
                                    onEnd={this.saveSignature}
                                    canvasProps={{
                                        width: this.state.canvasWidth,
                                        height: 200,
                                        className: 'sigCanvas',
                                        style: {
                                            width: '100%',
                                            maxWidth: '100%',
                                            height: '200px',
                                            border: '1px solid #ccc',
                                            borderRadius: 4,
                                        },
                                    }}
                                />
                                <div
                                    className="clear_signature_button"
                                    onClick={this.clear}
                                >
                                    Clear
                                </div>
                            </div>

                            {this.state.signatureError && (
                                <div
                                    className="mt-2"
                                    style={{ color: '#FC5A5A', fontSize: 13 }}
                                >
                                    {this.state.signatureError}
                                </div>
                            )}

                            <div className="mt-3">
                                <AppSelectField
                                    title={'Place of Signing'}
                                    value={this.state.placeOfSigning}
                                    placeholder={'Select state...'}
                                    options={this.state.stateList || []}
                                    fieldNames={{ label: 'reference1', value: 'code' }}
                                    onChange={(e) => this.setState({ placeOfSigning: e })}
                                />
                            </div>

                            <div className="mt-3">
                                <Checkbox
                                    onChange={(e) => this.handleChecked(e.target.checked)}
                                    checked={this.state.confirmSignature}
                                >
                                    I confirm and declare that the signature in the signature box above is my signature and is for mortgage takaful application. I also declare that I fully understand and agree with all the information and declarations in the attached documents, i.e. the Proposal Form and Product Illustration Sheet.
                                </Checkbox>
                            </div>
                        </div>
                    </div>

                    {this.showMessageModal()}

                    <AppModal
                        open={this.state.cancelModalOpen}
                        handleModalClose={() => this.handleCancelModalClose()}
                        title={'Do you want to cancel?'}
                        subtitle={"If you cancel, you might lose any progress you've made."}
                        negativeButtonText={'Yes, Cancel'}
                        positiveButtonText={'No, Continue'}
                        handleNegativePress={() => this.handleCancelReview()}
                        handlePositivePress={() => this.handleCancelModalClose()}
                        closable={false}
                    />
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({});

export default withRouter(connect(mapStateToProps)(ReviewSignature));